import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { AttributeDto } from './AttributeDto'
import { AttributeRequirementsString } from './AttributeRequirementsString'
import { AttributeRequirementsBool } from './AttributeRequirementsBool'
import { AttributeRequirementsInteger } from './AttributeRequirementsInteger'
import { AttributeRequirementsDecimal } from './AttributeRequirementsDecimal'
import { AttributeRequirementsDict } from './AttributeRequirementsDict'
import { AttributeRequirementsFile } from './AttributeRequirementsFile'
/**
* Class CategoryProductAttributeDto
*  Информация об атрибуте продукта, прикреплённому к категории
*/
export class CategoryProductAttributeDto extends ActiveModel {

  /**
  * attribute
  * Данные атрибута, который прикреплён к категории  */
  @ActiveField({
    factory: [AttributeDto, () => AttributeDto.create()]
  })
  attribute: AttributeDto = AttributeDto.create()


  /**
  * required
  * Если true, значит значение атрибута обязательно указывать для продуктов  */
  @ActiveField(false)
  required: boolean = false


  /**
  * isScalar
  * Если false, значит значение атрибута - это массив из<br>нескольких значений, иначе это одно значение<br>  */
  @ActiveField(false)
  isScalar: boolean = false


/**
  * config
  * Применяемые настройки атрибута  */
  @ActiveField({
  setter(model: CategoryProductAttributeDto, prop: string, value: AttributeRequirementsString | AttributeRequirementsBool | AttributeRequirementsInteger | AttributeRequirementsDecimal | AttributeRequirementsDict | AttributeRequirementsFile, receiver?: CategoryProductAttributeDto ) {
      let concreteValue = value
      switch (value.type) {
          case 'String': {
            concreteValue = AttributeRequirementsString.create(value)
            break;
          }
          case 'Bool': {
            concreteValue = AttributeRequirementsBool.create(value)
            break;
          }
          case 'Integer': {
            concreteValue = AttributeRequirementsInteger.create(value)
            break;
          }
          case 'Decimal': {
            concreteValue = AttributeRequirementsDecimal.create(value)
            break;
          }
          case 'Dict': {
            concreteValue = AttributeRequirementsDict.create(value)
            break;
          }
          case 'File': {
            concreteValue = AttributeRequirementsFile.create(value)
            break;
          }
      }

      return Reflect.set(
        model,
        prop,
        concreteValue,
        receiver
      )
    }
  })
  config: AttributeRequirementsString | AttributeRequirementsBool | AttributeRequirementsInteger | AttributeRequirementsDecimal | AttributeRequirementsDict | AttributeRequirementsFile | null | undefined = undefined
}
